import SuggestionHeading from './suggestion-heading';
export default SuggestionHeading;